// extracted by css-extract-rspack-plugin
export default {"cls1":"ArticlesSort-cls1_Gze","cls2":"ArticlesSort-cls2_5hN ArticlesSort-cls1_Gze"};